//MUI
import React, { useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import "./ModalMotivoCancelamento.scss";
import { useLoading } from "../../../../../../../shared/context/LoadingContext";
import { useHttpClient } from "../../../../../../../shared/hooks/http-hook";

import { fixSpaces } from "../../../../../../../shared/util/helperFunctions";

import PageviewIcon from "@mui/icons-material/Pageview";
import Alert from "@mui/material/Alert";

const motivosCancelamento = [
  { cod: 2, description: "Retificação - Art.º 65, n.º 2 CIVA" },
  { cod: 3, description: "Retificação - Art.º 65, n.º 3 CIVA" },
  { cod: 6, description: "Retificação - Art.º 65, n.º 6 CIVA" },
  { cod: 7, description: "Retificação - Art.º 65, n.º 7 CIVA" },
  { cod: 8, description: "Retificação - Art.º 65, n.º 8 CIVA" },
  { cod: 9, description: "Retificação - Art.º 65, n.º 9 CIVA" },
  { cod: 0, description: "Outro" },
];

const MOTIVOS_CONTINGENCIA = [
  { codigo: 1, label: "Indisponibilidade do serviço de autorização de DFEs" },
  { codigo: 2, label: "Falta de energia elétrica no estabelecimento" },
  { codigo: 3, label: "Indisponibilidade do sistema do contribuinte" },
  { codigo: 4, label: "Indisponibilidade de conexão Internet" },
  { codigo: 5, label: "Indisponibilidade do serviço de TimeStamp" },
  { codigo: 0, label: "Outro (especificar)" },
];

function ModalMotivoCancelamento({
  open,
  handleCloseModal,
  modalData,
  handleCancelarRecebimento,
  handleCancelarRecebimentoEntrada,
  clinica,
  auth,
}) {
  const requiresNifNome =
    modalData.tipoDocumentoAnular === "TVE" &&
    (!modalData.nif ||
      modalData.nif === "000000000" ||
      modalData.nif === "999999999");

  const { startLoading, stopLoading } = useLoading();
  const { sendRequest } = useHttpClient();
  const [motivoCancelamento, setMotivoCancelamento] = useState(
    motivosCancelamento[0],
  );
  const [motivoEvent, setMotivoEvent] = useState("");
  const [erro, setErro] = useState("");
  const [outro, setOutro] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Contingência
  const documentoOriginalEmContingencia =
    modalData.documentoEmContingencia || false;
  const [motivoContingenciaSelecionado, setMotivoContingenciaSelecionado] =
    useState(1);
  const [descricaoContingenciaOutro, setDescricaoContingenciaOutro] =
    useState("");

  const [nome, setNome] = useState(modalData.nome || "");
  const [nif, setNif] = useState(modalData.nif || "000000000");

  const [valorCancelar, setValorCancelar] = useState(modalData.valorTotal || 0);

  const motivosCancelamentoChangeHandler = (e) => {
    const selectedMotivo = motivosCancelamento.find(
      (m) => m.cod === parseInt(e.target.value),
    );
    setMotivoCancelamento(selectedMotivo);
  };

  const beforeSubmitHandler = () => {
    // Validação específica para Event
    if (modalData.tipoDocumento === "Event") {
      if (fixSpaces(motivoEvent).length < 10) {
        setErro(
          "Deve indicar pelo menos 10 caracteres no campo (Descrição de Motivo de Emissão de Event)",
        );
        return;
      }
      if (
        documentoOriginalEmContingencia &&
        motivoContingenciaSelecionado === 0 &&
        descricaoContingenciaOutro.trim().length < 10
      ) {
        setErro(
          "Descrição do motivo de contingência deve ter pelo menos 10 caracteres!",
        );
        return;
      }
      setIsSubmitting(true);
      submitHandler();
      return;
    }

    // Validação para NCE (fluxo original)
    if (
      motivoCancelamento.cod === 0 &&
      fixSpaces(motivoCancelamento.description).length < 10
    ) {
      setErro(
        `Motivo de emissão da ${modalData.tipoDocumento} teve ter 10 ou mais caracteres!`,
      );
      //Validar para caso seja necessário introduzir dados de cancelamento do NCE
    } else if (
      modalData.tipoCancelamento !== "entrada" &&
      (!valorCancelar ||
        valorCancelar <= 0 ||
        valorCancelar > modalData.valorTotal)
    ) {
      setErro(`Valor a cancelar deve ser entre 1 e ${modalData.valorTotal}$00`);
    } else if (
      documentoOriginalEmContingencia &&
      motivoContingenciaSelecionado === 0 &&
      descricaoContingenciaOutro.trim().length < 10
    ) {
      setErro(
        "Descrição do motivo de contingência deve ter pelo menos 10 caracteres!",
      );
    } else if (requiresNifNome) {
      if (
        !nif ||
        nif?.toString()?.trim() === "000000000" ||
        nif?.toString()?.trim() === "999999999"
      ) {
        setErro(
          "É necessário um NIF válido para a emissão do documento eletrónico!",
        );
      } else if (!nome || nome?.trim() === "") {
        setErro(
          "É necessário um Nome válido para a emissão do documento eletrónico!",
        );
      } else {
        setIsSubmitting(true);
        submitHandler();
      }
    } else {
      setIsSubmitting(true);
      submitHandler();
    }
  };

  const submitHandler = () => {
    setIsSubmitting(true);

    // Preparar dados de contingência se aplicável
    const dadosContingencia = documentoOriginalEmContingencia
      ? {
          ReasonTypeCode: motivoContingenciaSelecionado,
          ReasonDescription:
            motivoContingenciaSelecionado === 0
              ? descricaoContingenciaOutro.trim()
              : MOTIVOS_CONTINGENCIA.find(
                  (m) => m.codigo === motivoContingenciaSelecionado,
                )?.label,
        }
      : null;

    if (modalData.tipoCancelamento === "entrada") {
      handleCancelarRecebimentoEntrada(
        modalData.entrada,
        true,
        motivoCancelamento.cod === 0
          ? {
              cod: motivoCancelamento.cod,
              description: fixSpaces(outro),
            }
          : motivoCancelamento,
        modalData.tipoDocumento,
        requiresNifNome
          ? { nome: nome?.trim(), nif: nif?.toString()?.trim() }
          : null,
        dadosContingencia,
      );
    } else if (modalData.tipoDocumento === "Event") {
      // Anular RCE de parcela: passa só a string do motivo + contingência.
      handleCancelarRecebimento(
        modalData.id,
        fixSpaces(motivoEvent), // motivoCancelamento aqui é só a string
        "Event",
        null, // nomeENif não se aplica
        null, // valorCancelar não se aplica (Event = total)
        dadosContingencia,
      );
    } else {
      handleCancelarRecebimento(
        modalData.id,
        motivoCancelamento.cod === 0
          ? {
              cod: motivoCancelamento.cod,
              description: fixSpaces(outro),
            }
          : motivoCancelamento,
        modalData.tipoDocumento,
        requiresNifNome
          ? { nome: nome?.trim(), nif: nif?.toString()?.trim() }
          : null,
        valorCancelar,
        dadosContingencia,
      );
    }
    /////////////////////////////////
    setIsSubmitting(false);
    handleCloseModal();
  };

  const findClientInfo = async (nif, nomeToCheck) => {
    const formData = new FormData();
    nomeToCheck && formData.append("nome", nomeToCheck);
    nif && formData.append("nif", nif);
    try {
      startLoading();
      const response = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/documentoeletronico/nifbinome`,
        "PATCH",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        },
      );
      stopLoading();

      if (!response?.payload) {
        setErro("Nenhuma resposta da efatura");
      } else if (response.payload.length === 0) {
        setErro("Nenhum cliente encontrado");
      } else if (response.payload.length === 1) {
        setNome(response.payload[0].Name);
        setNome(response.payload[0].Name);
        if (!nome || nome.trim() === "") {
          setNome(response.payload[0].Name);
        }
        setNif(response.payload[0].TaxId);
      } else {
        // Caso encontrar mais do que um cliente
      }
    } catch (error) {
      stopLoading();
      console.error(error);
    }
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          className="fluxo-atendimento__modal__box motivoCancelamento__modal"
          id="modal__motivoCancelamento"
        >
          <h1 className="fluxo-atendimento__modal__titulo">
            Motivo emissão de {modalData.tipoDocumento} para cancelamento de{" "}
            {modalData.tipoDocumentoAnular}
          </h1>

          <div className="motivoCancelamento__modal__container">
            {modalData.tipoDocumento === "Event" ? (
              <textarea
                className="motivoCancelamento__modal__textarea"
                cols={4}
                rows={4}
                onChange={(e) => setMotivoEvent(e.target.value)}
                value={motivoEvent}
                placeholder="Descrição do motivo de emissão do Evento (mínimo 10 caracteres)"
              />
            ) : (
              <>
                <select
                  onChange={motivosCancelamentoChangeHandler}
                  className="motivoCancelamento__modal__select"
                >
                  {motivosCancelamento.map((m) => (
                    <option key={m.cod} value={m.cod}>
                      {m.description}
                    </option>
                  ))}
                </select>

                {modalData.tipoCancelamento !== "entrada" && (
                  <div className="form-input" style={{ marginTop: "20px" }}>
                    <input
                      id="valorCancelar"
                      name="valorCancelar"
                      type="number"
                      placeholder="0"
                      value={valorCancelar}
                      onChange={(e) => {
                        const valor = parseFloat(e.target.value);

                        if (isNaN(valor) || e.target.value === "") {
                          setValorCancelar("");
                        } else if (valor > modalData.valorTotal) {
                          setValorCancelar(modalData.valorTotal);
                        } else if (valor < 0) {
                          setValorCancelar(0);
                        } else {
                          setValorCancelar(valor);
                        }
                      }}
                      className="input"
                      step="0.01"
                      min="0"
                      max={modalData.valorTotal}
                    />
                    <label className="label" htmlFor="valorCancelar">
                      Valor a Cancelar (máx: {modalData.valorTotal}$00)
                    </label>
                  </div>
                )}

                {motivoCancelamento.cod === 0 && (
                  <textarea
                    className="motivoCancelamento__modal__textarea"
                    cols={4}
                    rows={4}
                    onChange={(e) => setOutro(e.target.value)}
                    value={outro}
                    placeholder={`Descrição do motivo de emissão da ${modalData.tipoDocumento}`}
                  />
                )}
              </>
            )}

            {documentoOriginalEmContingencia && (
              <>
                <Alert severity="warning" sx={{ mt: 2, mb: 2 }}>
                  O documento a cancelar foi emitido em{" "}
                  <strong>contingência</strong>. A Nota de Crédito será também
                  emitida em modo de contingência.
                </Alert>

                <div
                  className="customInputContainer"
                  style={{ marginBottom: "15px" }}
                >
                  <select
                    className="customInputSelect"
                    value={motivoContingenciaSelecionado}
                    onChange={(e) =>
                      setMotivoContingenciaSelecionado(Number(e.target.value))
                    }
                  >
                    {MOTIVOS_CONTINGENCIA.map((motivo) => (
                      <option key={motivo.codigo} value={motivo.codigo}>
                        {motivo.label}
                      </option>
                    ))}
                  </select>
                  <label className="customInputLabelSelect">
                    Motivo da Contingência *
                  </label>
                </div>

                {motivoContingenciaSelecionado === 0 && (
                  <textarea
                    className="motivoCancelamento__modal__textarea"
                    cols={4}
                    rows={3}
                    onChange={(e) =>
                      setDescricaoContingenciaOutro(e.target.value)
                    }
                    value={descricaoContingenciaOutro}
                    placeholder="Especifique o motivo da emissão em contingência (mínimo 10 caracteres)..."
                  />
                )}
              </>
            )}

            {requiresNifNome && (
              <>
                <div
                  className="takes2-5 form-input"
                  style={{ marginTop: "25px", marginBottom: "15px" }}
                >
                  <input
                    id="nome"
                    name="nome"
                    type="text"
                    placeholder="Nome Fiscal"
                    value={nome}
                    onChange={(e) => setNome(e.target.value)}
                    className="input"
                  />
                  <label className="label" htmlFor="nome">
                    Nome Fiscal
                  </label>
                  <PageviewIcon
                    className="icon-search-field"
                    onClick={findClientInfo.bind(null, null, nome)}
                  />
                </div>

                <div className="form-input takes3-5">
                  <input
                    id="nif"
                    name="nif"
                    type="text"
                    placeholder="1333333"
                    value={nif}
                    onChange={(e) => setNif(e.target.value)}
                    className="input"
                  />
                  <label className="label" htmlFor="nif">
                    Nif
                  </label>
                  <PageviewIcon
                    className="icon-search-field"
                    onClick={findClientInfo.bind(null, nif, null)}
                  />
                </div>
              </>
            )}
          </div>

          <div className="motivoCancelamento__modal__erro">{erro && erro}</div>

          <div
            style={{
              gridColumn: "1/-1",
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
            }}
          >
            <span
              className="blue-button"
              disabled={isSubmitting}
              onClick={beforeSubmitHandler}
            >
              {isSubmitting ? "Guardando..." : "Guardar"}
            </span>

            <span
              className="cancel-btn"
              onClick={handleCloseModal}
              style={{ display: "block" }}
            >
              Fechar
            </span>
          </div>
        </Box>
      </Modal>
    </>
  );
}

export default ModalMotivoCancelamento;
